// Licences / approvals and awards.
// ⚠️ PLACEHOLDER — confirm every authority with the client before going live, and fill `number`
// only with the real licence / registration number. Remove anything the hospital does not hold.
// An empty `awards` array hides the Awards section automatically.

export const licenses = [
  { id: 1, abbr: "DGHS", name: "Directorate General of Health Services", authority: "Ministry of Health & Family Welfare", status: "Licensed", number: "" },
  { id: 2, abbr: "DNC", name: "Department of Narcotics Control", authority: "Ministry of Home Affairs", status: "Licensed", number: "" },
  { id: 3, abbr: "TL", name: "Trade Licence", authority: "Kishoreganj Paurashava", status: "Registered", number: "" },
  { id: 4, abbr: "FIRE", name: "Fire Service & Civil Defence", authority: "Fire Safety Licence", status: "Licensed", number: "" },
  { id: 5, abbr: "DoE", name: "Department of Environment", authority: "Environmental Clearance", status: "Cleared", number: "" },
  { id: 6, abbr: "TIN", name: "Tax Identification Number", authority: "National Board of Revenue", status: "Registered", number: "" },
];

export const licensesContent = {
  title: "Licensed & Approved",
  subtitle: "Unity Health Centre operates with the required government approvals.",
};

// Example shape: { id: 1, year: "2026", title: "Best Rehabilitation Centre", by: "Awarding body", img: "/assets/images/..." }
export const awards = [];

export const awardsContent = {
  title: "Awards & Recognition",
  subtitle: "Recognition for our commitment to ethical, high-quality care.",
};

// Small badges shown under the home contact boxes
export const trustBadges = [
  { icon: "icon-call3", title: "24/7 Emergency", desc: "Always available" },
  { icon: "icon-hospital", title: "Separate Units", desc: "Male & female wards" },
  { icon: "icon-doctor", title: "Expert Team", desc: "Psychiatrists & psychologists" },
  { icon: "icon-heart", title: "100% Confidential", desc: "Your privacy protected" },
];
